<template>
  <div class="h-100">
    <div v-if="loading" class="h-100 flex justify-content-center align-items-center">
      <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
    </div>
    <template v-else>
      <template v-if="!dialogs">
        <h5>Диалогов не найдено</h5>
      </template>
      <template v-else>
        <div class="row m-0">
          <div class="col-md-3 card p-0 dialogs_block">
            <div class="card-body">
              <div v-for="dialog in dialogs" :key="dialog.id"
                   v-bind:class="{'dialog_select': true, 'active': selectedDialog && selectedDialog.id === dialog.id}"
                   @click="selectDialog(dialog.id)">
                <p v-for="u in dialog.users">{{ u.user.name }}</p>
                <p class="text-muted text-right chat_date">(U:{{ dialog.user_id }} {{ dialog.id }})
                  {{ printDate(dialog.created_at, 'DD.MM HH:mm') }}</p>

              </div>
            </div>
          </div>
          <div class="col-md-9 card p-0">
            <div class="card-body">
              <LoadingButton
                v-if="allowToClose"
                title="Решено"
                type="button"
                :loading="sendLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => acceptDialog(true)"
                className="btn btn-outline-success close_btn"
              />
              <template v-if="!selectedDialog">
                <h5>Выберите диалог</h5>
              </template>
              <template v-else>
                <div class="messages_list">
                  <div v-for="message in selectedDialog.messages" :key="message.id"
                       v-bind:class="{'single_message': true, 'my_message': +message.user_id === $currentUID }">
                    <div class="author">
                      {{ users[message.user_id] && users[message.user_id].name || 'не указано' }}
                      <span
                        class="text-muted message_date">{{ printDate(message.created_at, 'DD.MM HH:mm') }}</span></div>
                    <div class="triangle"></div>
                    <div class="message">
                      {{ message.message }}
                      <span class="read_marker" v-if="message.acknowledge_by">
                      {{ printDate(message.acknowledge_by[0].date, 'DD.MM HH:mm', false, 0) }} <i
                        class="icon-fa icon-fa-check"></i>
                    </span>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="sendMessage" v-if="selectedDialog.is_active">
                  <div class="input-group">
                    <input type="text" :disabled="sendLoading" v-model="message" required class="form-control br-0"
                           placeholder="Сообщение">
                    <div class="input-group-append">
                      <LoadingButton
                        title="Отправить"
                        type="submit"
                        :loading="sendLoading"
                        :color="$constants.LOADING_COLOR"
                        :onClick="() => {}"
                        className="btn btn-outline-info br-0"
                      />
                    </div>
                  </div>
                </form>

              </template>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['orderId'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: true,
      sendLoading: false,
      dialogs: null,
      selectedDialog: null,
      users: {},
      message: null,
      allowToClose: false,
    }
  },
  mounted() {
    this.getChats()
  },
  methods: {
    async getChats() {
      this.loading = true;
      const {data} = await api.index('/new/chat/order/' + this.orderId)
      if (data.success) {
        this.users = data.records.reduce((acc, r) => {
          r.users.forEach((u) => {
            acc[u.user.id] = u.user;
          })
          return acc;
        }, {})
        this.dialogs = data.records.reduce((acc, r) => {
          acc.push({...r, users: r.users.reverse()})
          return acc;
        }, []);
      }
      this.loading = false;
    },
    selectDialog(id) {
      this.selectedDialog = this.dialogs.find((d) => d.id === id);
      if (this.selectedDialog.is_active && this.selectedDialog.user_id === this.$currentUID) {
        this.allowToClose = true;
      }
    },
    async acceptDialog(close = false) {
      this.btnLoading = true;
      const {data} = await api.post('/new/chat/update', {
        type: close ? 'closeDialog' : 'acceptDialog',
        dialog_id: this.selectedDialog.id,
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        this.dialogs = this.dialogs.filter((d) => +d.id !== +this.selectedDialog.id)
        this.selectedDialog = null;
      }
      this.btnLoading = false;
    },
    async sendMessage(e) {
      this.sendLoading = true;
      const {data} = await api.post('/new/chat/update', {
        type: 'newMessage',
        dialog_id: this.selectedDialog.id,
        message: this.message
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        const index = this.dialogs.findIndex((d) => d.id === this.selectedDialog.id);
        this.dialogs[index].messages.push({message: this.message, user_id: this.$currentUID});
        this.selectDialog(this.selectedDialog.id);
        this.message = null;
      }
      this.sendLoading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}

.dialog_select {
  cursor: pointer;
  border: 1px solid lightgray;
  padding: 5px;
}

.dialogs_block {
  padding: 5px;
  padding-top: 0;
}

.messages {
  border: 1px solid lightgray;
  padding: 5px;
  height: 75vh;
  position: relative;
}

.dialog_select:hover {
  background-color: #fbfbfb;
}

.dialog_select.active {
  background-color: #def1f8;
}

.chat_date {
  font-size: 11px;
}

.my_message .triangle {
  position: absolute;
  right: 0;
  top: 40px;
  transform: rotate(90deg);
}

.message_date {
  font-size: 11px;
}

.single_message {
  margin-bottom: 3px;
  max-width: 80%;
}

.single_message.my_message {
  align-self: self-end;
  text-align: right;
  position: relative;
  margin-right: 14px;
  width: 80%;
}

.triangle {
  border-color: transparent transparent #def1f8 transparent;
  margin-left: 15px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
}

.read_marker {
  position: absolute;
  bottom: -3px;
  right: 19px;
  font-size: 14px;
  color: green;
  opacity: .4;
}

.message {
  background-color: #def1f8;
  padding: 10px;
  /*color: #fff;*/
  line-height: 25px;
  max-width: 90%;
  display: inline-block;
  text-align: left;
  border-radius: 5px;
  position: relative;
  padding-bottom: 15px;
  min-width: 130px;
}

.messages_list {
  height: calc(100% - 53px);
  overflow: auto;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.close_btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
